<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表
							<span style="margin-left: 15px">总用电量： {{totalObj.elecTotal ? parseFloat(totalObj.elecTotal).toFixed(2) : 0 }}度</span>
							<span style="margin-left: 15px">配额抵扣： {{totalObj.quotaTotal ? parseFloat(totalObj.quotaTotal).toFixed(2) : 0 }}度</span>
							<span style="margin-left: 15px">金额抵扣： {{totalObj.moneyTotal ? parseFloat(totalObj.moneyTotal).toFixed(2) : 0 }}元</span>
						</div>
						<div class="search-tools">
							<el-button type="primary" @click="exportExcel">导出</el-button>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					>
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="elecDate" label="日期" align="center"></el-table-column>
						<el-table-column prop="elecTotal" label="用电量（度）" align="center"></el-table-column>
						<el-table-column prop="quotaTotal" label="配额用量（度）" align="center"></el-table-column>
						<el-table-column prop="moneyTotal" label="学生钱包扣费（元）" align="center"></el-table-column>
					</el-table>

					<!-- <el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination> -->
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
// 总用量报表
import { getDailyTotal } from '@/apis/orange'

export default {
	name: "DailyTotal",	// 报表
	data() {
		return {
			loading: false,
			nowDate: '',
			searchForm: {},
			dateRange: [],
			dateRangeMoren: [],

			// total: 0,
			// size: 10,
			// current: 1,

			tableData: [],
			totalObj: {}
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		let t = new Date()
		let startDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-01'
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		this.dateRange = [startDate, endDate]
		this.dateRangeMoren = [startDate, endDate]
		this.get_baobiao()
	},
	methods: {
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_baobiao()
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let beginDate = this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0]
			let endDate = this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			getDailyTotal({beginDate, endDate}).then(res => res.data).then(res => {
				this.tableData = res.data
				this.total = res.total.totalCount
				this.totalObj = res.total
				loading.close()
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, elecDate: it.elecDate, elecTotal: it.elecTotal, quotaTotal: it.quotaTotal, moneyTotal:it.moneyTotal }))
						excelData.push({})
						excelData.push({})
						excelData.push({index: '合计', elecTotal: this.totalObj.elecTotal, quotaTotal: this.totalObj.quotaTotal, moneyTotal:this.totalObj.moneyTotal})
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '日期', '用电量（度）', '配额用电（度）', '学生钱包扣费（元）']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `总用量报表${this.nowDate}.xlsx`)
        },
		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.editForm = {}
		},
		get_baobiao() {
			this.loading = true
			let beginDate = this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0]
			let endDate = this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			getDailyTotal({ beginDate, endDate }).then(res => res.data).then(res => {
				// console.log(res);
				this.loading = false
				this.tableData = res.data
				this.total = res.total.totalCount
				this.totalObj = res.total
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>